import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBulkUpload = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M1.66699 15.7172V9.57227C1.66699 8.4677 2.56242 7.57227 3.66699 7.57227H11.2612C12.3658 7.57227 13.2612 8.4677 13.2612 9.57227V15.7172C13.2612 16.8218 12.3658 17.7172 11.2612 17.7172H3.66699C2.56242 17.7172 1.66699 16.8218 1.66699 15.7172Z",
			stroke: "currentColor",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.2611 15.1811H13.7973C14.9019 15.1811 15.7973 14.2856 15.7973 13.1811V7.03613C15.7973 5.93156 14.9019 5.03613 13.7973 5.03613H6.20312C5.09856 5.03613 4.20312 5.93156 4.20312 7.03613V7.57236",
			stroke: "currentColor",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.1595 12.6449H16.3335C17.438 12.6449 18.3335 11.7495 18.3335 10.6449V4.5C18.3335 3.39543 17.438 2.5 16.3335 2.5H8.73926C7.63469 2.5 6.73926 3.39543 6.73926 4.5V4.67391",
			stroke: "currentColor",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.53781 9.67383C7.53781 10.8346 7.53781 11.7339 7.53781 12.6398M7.53781 15.4709C7.53781 14.3678 7.53781 13.5008 7.53781 12.6398M7.53781 12.6398C8.64093 12.6398 10.3625 12.6398 10.3625 12.6398M7.53781 12.6398H4.56543",
			stroke: "currentColor",
			strokeWidth: 1.5
		})
	]
});
export default SvgBulkUpload;
